module.exports = __webpack_public_path__ + "static/media/avatar.a6e08858.png";